import axios from 'axios';
import { urlsServices } from '@/config/urls';

let httpUrl = `${urlsServices.GETWAY}api/formbuilder-respostas`;
export const createRespostas = async (profissional) => {
  return await axios.post(`${httpUrl}/create`, profissional).then((response) => response);
};

export const getFormRespostas = async (obj) => {
  return await axios
    .get(`${httpUrl}/list`, {
      params: obj,
    })
    .then((response) => response);
};

export const getFormRespostasById = async (id) => {
  return await axios.get(`${httpUrl}/${id}`).then((response) => response);
};

export const getFormRespostasByCpf = (cpf) => {
  return axios.get(`${httpUrl}/cpf/${cpf}`, null, { ignoreInterceptors: true }).then((response) => response);
};

export const getFormRespByIdRegistroAtendimento = async (idRegistroAtendimento) => {
  return await axios.get(`${httpUrl}/registro-atendimento/${idRegistroAtendimento}`).then((response) => response);
};
